import React from 'react';
import { useDispatch } from 'react-redux';
import { setLang } from '../store/langSlice';

export default function Lang({
  lang
}) {
  const dispatch = useDispatch();
  return (
    <div className='flex justify-between items-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
      <span onClick={() => dispatch(setLang('ar'))} className={`px-2 rounded-l-full cursor-pointer border-primary border ${lang === 'ar' ? 'text-primary bg-white hover:text-white hover:bg-primary' : 'text-white bg-primary hover:text-primary hover:bg-white'}`}>AR</span>
      <span onClick={() => dispatch(setLang('fr'))} className={`px-2 cursor-pointer border-primary border ${lang === 'fr' ? 'text-primary bg-white hover:text-white hover:bg-primary' : 'text-white bg-primary hover:text-primary hover:bg-white'}`}>FR</span>
      <span onClick={() => dispatch(setLang('en'))} className={`px-2 rounded-r-full cursor-pointer border-primary border ${lang === 'en' ? 'text-primary bg-white hover:text-white hover:bg-primary' : 'text-white bg-primary hover:text-primary hover:bg-white'}`}>EN</span>
    </div>
  );
}
